export default __webpack_public_path__ + "static/media/hero-logo-1.501c64c8.png";